export function gtmInit(gtmid) {
  const gtmscript = document.createElement('script')
  gtmscript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmid}');`
  document.head.appendChild(gtmscript)

  const gtmbodyscript = document.createElement('noscript')
  gtmbodyscript.text = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmid}"height="0" width="0" style="display:none;visibility:hidden"></iframe>`
  document.body.appendChild(gtmbodyscript)
}

// GTM 電子商務 API 簡易版 //
const gtmViewItem = (items, currency, value) => {
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: "view_item",
    ecommerce: { currency, value, items }
  })
}

const gtmAddToCart = (items, currency, value) => {
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: { currency, value, items }
  })
}

const gtmBeginCheckout = (items, currency, value) => {
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: "begin_checkout",
    ecommerce: { currency, value, items }
  })
}

const gtmPurchase = (items, currency, value, transaction_id) => {
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: "purchase",
    ecommerce: { currency, value, transaction_id, items }
  })
}

export { gtmViewItem, gtmAddToCart, gtmBeginCheckout, gtmPurchase }
